require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/es7.symbol.observable.js
// module id = 220
// module chunks = 0